<template>
  <div class="instrument-list__container">
    <p class="text-h-2 instrument-list__header instrument-list--primary">
      {{ searchText }}
    </p>
    <p
      v-if="hasLength"
      class="text-p-5 instrument-list__results instrument-list--secondary"
    >
      {{ searchItemsData.length }} {{ searchResultsDescription }}
    </p>
    <a
      v-for="item in searchItemsData"
      :key="item.symbol"
      href="#"
      :aria-label="`Ver detalhes do ativo ${item.symbol}`"
      @click.prevent="handleRowClick(item)"
    >
      <InstrumentRow
        :instrument="item"
        :has-chevron="chevron"
        :show-watch-list-button="showWatchListButton"
        has-ellipsis
        @on-watchlist-click="() => emitWatchlistClick(item)"
      />
    </a>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

import { InstrumentRow } from '../InstrumentRow';
import { Row } from '@warrenbrasil/nebraska-web';

import { Instrument } from '@/modules/trade/services/search';

@Component({
  components: {
    InstrumentRow,
    Row
  }
})
export default class InstrumentList extends Vue {
  @Prop({ type: String, default: '' })
  readonly searchText!: string;

  @Prop({ type: Array, required: true })
  readonly searchItemsData!: Instrument[];

  @Prop({ type: Boolean, default: false })
  readonly hasLength!: boolean;

  @Prop({ type: Function, required: true })
  readonly onRowClick!: (instrument: Instrument) => {};

  @Prop({ type: Boolean, default: true })
  readonly chevron!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly showWatchListButton!: boolean;

  @Emit('on-watchlist-click')
  emitWatchlistClick(instrument: Instrument) {
    return instrument;
  }

  get searchResultsDescription() {
    return this.searchItemsData.length
      ? 'resultado encontrado'
      : 'resultados encontrados';
  }

  handleRowClick(instrument: Instrument) {
    this.onRowClick(instrument);
  }
}
</script>

<style scoped lang="less">
.instrument-list {
  &__header {
    margin-bottom: @size-spacing-x150;
  }
  &__results {
    margin-bottom: @size-spacing-x400;
  }
  &--primary {
    color: @text-primary;
  }
  &--secondary {
    color: @text-secondary;
  }
  &--positive {
    color: @monetary-positive;
  }
  &--negative {
    color: @monetary-negative;
  }
}
</style>
